import { ICoherenceHeaderProps } from '@coherence-design-system/controls/lib/header';

export function useHeaderConfig(): ICoherenceHeaderProps {
  return {
    headerLabel: __APP_NAME__,
    styles: {
      subComponentStyles: {
        appNameLink: {
          root: {
            borderLeft: '1px solid #106EBE',
            margin: '-1px 0px 0px -9px',
            paddingLeft: '17px',
          },
        },
      },
    },
    appNameSettings: {
      label: __APP_NAME__,
    },
    searchSettings: {
      placeholder: 'Search...',
      onSearch: (term: string): void => alert(term),
    },
  };
}
